export default "__VITE_ASSET__CXc9G2cW__"